<template>
  <div>
    <attachment
      :noviRadDialog="noviRadDialog"
      :isInEdit="isInEdit"
      :selectedRad="selectedRad"
      class="pl-0 pr-0"
    ></attachment>
    <div style="width: 100%">Dodaj linkove rada:</div>
    <v-divider></v-divider>
    <v-row class="d-flex justify-center align-center">
      <v-col :cols="getDeviceType === 'touch' ? 12 : 5">
        <v-text-field
          outlined
          dense
          v-model="link"
          label="Unesi link"
        ></v-text-field>
      </v-col>
      <v-col
        :cols="getDeviceType === 'touch' ? 12 : 5"
        :class="!$vuetify.breakpoint.mdAndUp ? 'pt-0 mt-n3' : ''"
      >
        <v-text-field
          outlined
          v-model="opis_linka"
          dense
          label="Unesi opis linka"
        ></v-text-field>
      </v-col>
      <v-col
        :cols="getDeviceType === 'touch' ? 12 : 2"
        :class="
          getDeviceType === 'touch' ? 'd-flex justify-center align-center' : ''
        "
      >
        <v-btn
          color="primary"
          class="mt-n8"
          small
          :disabled="!link && !opis_linka"
          @click="dodajLinkRada"
        >
          Dodaj link
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      ><v-col :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'">
        <v-card
          elevation="1"
          class="pa-0 mb-2"
          color="accent"
          v-for="link in getLinkovi"
          :key="link.opis_linka"
        >
          <v-card-title
            class="d-flex justify-center align-center pa-0 pr-3 pl-3"
          >
            <h5 style="width: 80%; word-break: break-word">
              "{{ link.link }}"
            </h5>
            <v-spacer></v-spacer>
            <v-btn fab icon @click="ukloniLinkRada(link)">
              <v-icon color="primary">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="max-height: 200px; overflow-y: auto">
            <div style="max-width: 100%">
              {{ link.opis_linka }}
            </div>
          </v-card-text>
        </v-card>
      </v-col></v-row
    >
  </div>
</template>
<script>
import Attachment from "../../components/Attachment";
import { mapGetters } from "vuex";
export default {
  props: ["noviRadDialog", "isInEdit", "selectedRad"],
  components: {
    Attachment,
  },
  computed: {
    ...mapGetters(["getFiles", "getLinkovi", "getDeviceType"]),
  },
  data() {
    return {
      link: null,
      opis_linka: null,
      links: [],
      // filename: null,
      // fileUrl: null,
      // file: null,
    };
  },

  methods: {
    dodajLinkRada() {
      let noviLink = {
        link: this.link,
        opis_linka: this.opis_linka,
      };
      // if (!this.getLinkovi.includes(noviLink)) {
      // this.getLinks.push(noviLink)
      this.$store.dispatch("setLinks", noviLink);
      // }
      this.link = null;
      this.opis_linka = null;
    },
    ukloniLinkRada(link) {
      if (this.isInEdit && Object.prototype.hasOwnProperty.call(link, "id")) {
        this.$store.dispatch("deleteLinkById", { linkId: link.id });
      }
      let selectedToDelete = this.getLinkovi.find((SA) => SA.id === link.id);
      let index = this.getLinkovi.indexOf(selectedToDelete);
      if (index > -1) {
        this.getLinkovi.splice(index, 1);
      }
    },
  },
};
</script>
